import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { PhxDragItemComponent } from '../base/phx-drag-item.component';

@Component({
  selector: 'phx-drag-item-inline',
  templateUrl: './phx-drag-item-inline.component.html',
  styleUrls: ['./phx-drag-item-inline.component.scss', '../base/phx-drag-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-drag-item phx-drag-item-inline',
    '[class.phx-drag-item-no-handle]': '!hasDragHandle && !isViewMode',
  },
  providers: [{ provide: PhxDragItemComponent, useExisting: PhxDragItemInlineComponent }],
})
export class PhxDragItemInlineComponent extends PhxDragItemComponent {
  @Input() phxDragWithinParent: boolean = true;
}
